import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=49372219"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=49372219&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports